import AuthModel from '../models/AuthModel'

const issue = (state, action) => {

    if (!state) {

        // Init state
        state = {
            id: '',
            email: '',
            username: '',
            entidade: '',
            authToken: '',
            complete: false,
            error: ''
        }

        // Check logged user
        if (AuthModel.isAuthenticated()) {
            const logged = AuthModel.getLoggedUser()
            state.id = logged.id
            state.username = logged.username
            state.entidade = logged.entidade
            state.authToken = logged.auth_token
        }

    }

    switch (action.type) {

        case 'LOGIN':
        return {
            ...state,
            complete: true,
            error: '',
            id: action.id,
            email: action.email,
            username: action.username,
            entidade: action.entidade,
            authToken: action.authToken
        }

        case 'LOGIN_ERROR':
        return {
            ...state,
            complete: true,
            error: action.error
        }

        case 'LOGIN_RESET':
        return {
            ...state,
            complete: action.complete,
            error: action.error,
            username: action.username,
            authToken: action.authToken
        }

        case 'LOGOUT':
        return {
            ...state,
            complete: action.complete,
            error: action.error,
            username: action.username,
            id: action.id,
            authToken: action.authToken
        }

        case 'RECOVER_START_SUCCESS':
        return {
            ...state,
            complete: true,
            error: '',
            result: action.result
        }

        case 'RECOVER_START_ERROR':
        return {
            ...state,
            complete: true,
            error: action.error
        }

        case 'RECOVER_START_RESET':
        return {
            ...state,
            complete: action.complete,
            error: action.error,
            username: action.username
        }

        case 'RECOVER_SUCCESS':
        return {
            ...state,
            complete: true,
            error: ''
        }

        case 'RECOVER_ERROR':
        return {
            ...state,
            complete: true,
            error: action.error
        }

        case 'RECOVER_RESET':
        return {
            ...state,
            complete: action.complete,
            error: action.error,
            recover_token: action.recover_token
        }

        default:
        return state
    }
}

export default issue



// WEBPACK FOOTER //
// ./src/reducers/auth.js